import moment from 'moment';

export const getStartEndDate = (duration) => {
  switch (duration) {
    case 'Last 30 days':
      return { startDate: moment().startOf('day').add(-30, 'days').toISOString(), endDate: moment().endOf('day').toISOString() };

    case 'Last 60 days':
      return { startDate: moment().startOf('day').add(-60, 'days').toISOString(), endDate: moment().endOf('day').toISOString() };

    case 'Last 90 days':
      return { startDate: moment().startOf('day').add(-90, 'days').toISOString(), endDate: moment().endOf('day').toISOString() };

    default:
      return null;
  }
};

export const DATE_FORMAT = {
  DATE_FORMAT_SHORT: 'MM/DD/YYYY',
  DATE_FORMAT_FULL: 'MMM DD, YYYY',
};

export const formatDate = (date, defaultFormat = DATE_FORMAT.DATE_FORMAT_FULL) => {
  return date && moment(date).format(defaultFormat);
};
